'use client';

import { useCallback, useState } from 'react';
import { useExperiments } from '@alltrails/experiments';
import type WebList from '@alltrails/types/WebList';

export default function useSaveSuccessToast() {
  const experiments = useExperiments();
  const [isOpen, setIsOpen] = useState(false);
  const [savedLists, setSavedLists] = useState<WebList[]>([]);

  const onSaveToListModalClose = useCallback(
    (lists: WebList[]) => {
      if (experiments['web-growth-rm-save-toast']?.value !== 'treatment' || lists.length === 0) {
        return;
      }

      setSavedLists(lists);
      setIsOpen(true);
    },
    [experiments]
  );

  return {
    isOpen,
    onSaveToListModalClose,
    savedLists,
    setIsOpen
  };
}
